import React from 'react'
import { Grid, Image, H, P } from '@farewill/ui'

const Privacy = () => (
  <Grid
    container
    containerPaddingTop="L"
    containerPaddingBottom="L"
    style={{ alignItems: 'center' }}
  >
    <Grid.Item spanFromM={8} spanFromL={7}>
      <H size="L" decorative>
        Privacy guaranteed
      </H>
      <P>
        Writing a will is a very private matter, so we’ve made it possible to
        make one from the privacy of your own home. And because of our
        world-class security systems, you can rest assured that the content of
        your will is completely secure and&nbsp;confidential.
      </P>
    </Grid.Item>
    <Grid.Item spanFromM={4} spanFromL={5} centered>
      <Image
        path="illustrations/cropped/cat-privacy"
        width={200}
        widthFromM={300}
        stretch
      />
    </Grid.Item>
  </Grid>
)

export default Privacy
